// extracted by mini-css-extract-plugin
export default {"update_permission_submit_action_row":"Permissions_update_permission_submit_action_row__R7EQ2","update_permission_input":"Permissions_update_permission_input__rg1wi"};